import React from 'react';
import { Asset } from '../../../types/asset';

interface FullWidthBlurbProps {
    title: string;
    description: string;
    backgroundImage: Asset;
}

export const FullWidthBlurb: React.FC<FullWidthBlurbProps> = ({
   title,
   description,
   backgroundImage,
}) => {
    return (
        <div
            className={'bg-cover bg-center'}
            style={{ backgroundImage: `url(${backgroundImage.url})` }}
        >
            <div className={'px-2 max-w-5xl mx-auto sm:px-8 text-white py-52 bg-cover bg-center'}>
                <p className={'text-3xl font-bold leading-10'}>{title}</p>
                <p className={'mt-8 w-1/2'}>{description}</p>
            </div>
        </div>
    );
};
